import React from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import styles from "../../styles";
import { KeyValueTable, SectionTitle } from "../../shared";

const FindingsSection = ({ supplierData = {}, meta }) => {
    const findings = Array.isArray(supplierData?.news) ? supplierData.news : [];
    const findingRows = findings.map((finding, index) => ({
        title: `${index + 1}. ${finding?.news_agency || "-"}`,
        details: finding?.title || finding?.keyword || "-",
    }));

    return (
        <View style={styles.wordSectionContent}>
            <KeyValueTable
                leading={(
                    <SectionTitle
                        title={meta?.title || "Findings"}
                        number={meta?.number}
                        anchorId={meta?.anchorId}
                    />
                )}
                rows={findingRows}
                titleColumnLabel="Source"
                detailsColumnLabel="Description"
            />
        </View>
    );
};

export default withNamespaces()(FindingsSection);
